// eslint-disable-next-line import/prefer-default-export
export const PAGE_NOT_FOUND_MSG = "The page you requested could not be found.";
export const PAGE_NOT_FOUND = "Page Not Found ...";
export const PAGE_NOT_FOUND_TITLE = "404";
export const FOOTER_ALL_RIGHTS_RESERVED = "All rights reserved.";
export const FOOTER_WHELEN = "Whelen Engineering.";
export const AGREE_TO_TERMS = "I have read and agree to the AOG";
export const END_USER_LICENSE_AGREEMENT = "End User License Agreement";
export const TROUBLE_LOGGING_IN = "Trouble Logging In?";
export const AOG_GUIDE = "Apparatus Outfitting Guide";
export const IGNORE_FAILED_ZONES = "Ignore failed zones";
export const REVISIT_CONFIG = "Revisit an existing configuration";
export const START_NEW_CONFIG = "Start a new configuration";
export const NO_CONFIG = "No Configuration Available";
export const REFRESH_SESSION = "Refresh Session";
export const SESSION_EXP_NOTIFICATION = "Session Expiration Notification";
export const CONFIG_DETAILS = "Configuration Details";
export const AOG_TUTORIAL = "AOG Tutorial";
export const END_USER_AGREEMENT = "End User License Agreement";
export const RELEASE_NOTES = "Release Notes";
export const LEARN_MORE_FAQ = "Learn more in the FAQ";
export const PLS_REFER = "Please refer";
export const FOR_DETAILS = "for details";
export const SAVE_CONFIG_DETAILS = "Save Configuration Details";
export const PLS_SELECT = "Please Select";
export const CHOOSE_SERIES_MODEL = "Choose a light series and model";
export const IMPORT_BXR_FROM = "Or import a .bxr file from wecad";
export const LIGHT_SOURCE_NOTE =
  "The following light source(s) will not contribute to cetain zones due to either non-permissible color contribution in adjacent zone(Fringe Flux), non-permissible light color in zone or non-permissible color in select mode of operation.";
export const PRINT_NON_PERMISSIBLE_COLOR_NOTE =
  "Print the list of Non-Permissible Color Light Source along with Zone value and Reason.";
export const CHOOSE_ZONE_OBSTRUCT = "Choose zones that obstruct this light source";
export const LIGHT_SOURCE_CALCULATION = " Lightsource to include in the calculation ";
export const CONFIG_NAME_REQUIRED = "Config Name is required";
export const SAVE_AS_CONFIGURATION = "Save As Configuration";
export const SHARE_CONFIGURATION = "Share Configuration";
export const ADD_LIGHT_SOURCE = "Add a Light Source";
export const MY_SAVED_LIGHT_SOURCES = "My Saved Light Sources";
export const EXCLUDED_INACTIVE_LIGHTHEADS_INFO =
  "Information from the excluded and/or inactive lighthead(s) will be used in the calculation, however it may be inaccurate.";
export const EXCLUDED_INACTIVE_LIGHTHEADS_CONFIGUARTION =
  "Excluded and/or inactive lighthead(s) found in this configuration";
export const EXCLUDED_INACTIVE_LIGHTHEADS_CALCULATION_INFO =
  "The excluded and/or inactive lighthead(s) will not be considered during the calculation.";
